export const CONFIRM_DIALOG_ICON_SIZE = 28;

export const ICON_SIZES = {
  XXS: 12,
  XS: 16,
  SM: 24,
  MD: 32,
  MD_LG: 32 + 8,
  LG: 48,
  XL: 64,
  GRID: 13,
  GRID_CELL_ICON: 10,
};
